// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Services Page Styles */
.services-page {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.services-main {
  padding-top: 120px;
  min-height: 100vh;
}

.services-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header Section */
.services-header {
  text-align: center;
  margin-bottom: 60px;
}

.services-title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

.services-emoji {
  font-size: 48px;
  animation: bounce 2s infinite;
}

.services-title {
  font-size: 48px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.services-subtitle {
  font-size: 18px;
  color: var(--text-secondary);
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Services Content */
.services-content {
  margin-bottom: 80px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 80px;
}

.service-card {
  background: var(--accent-cream);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  padding: 32px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px var(--shadow-color);
}

/* Dark theme card background */
[data-theme="dark"] .service-card {
  background: rgba(44, 62, 80, 0.9);
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--accent-coffee), var(--accent-beige));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px var(--shadow-color);
  border-color: var(--accent-coffee);
}

.service-card:hover::before {
  opacity: 1;
}

.service-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.service-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--accent-coffee), var(--accent-beige));
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.service-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

.service-description {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 24px;
}

.service-features {
  margin-bottom: 24px;
}

.features-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.feature-icon {
  width: 20px;
  height: 20px;
  background: var(--accent-coffee);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--accent-cream);
  flex-shrink: 0;
}



/* Animations */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .services-container {
    padding: 0 16px;
  }
  
  
  .services-title {
    font-size: 36px;
  }
  
  .services-subtitle {
    font-size: 16px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .service-card {
    padding: 24px;
  }
  
  .service-title {
    font-size: 20px;
  }
  
}

@media (max-width: 480px) {
  .services-title {
    font-size: 28px;
  }
  
  .service-card {
    padding: 20px;
  }
  
  .service-header {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .service-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/pages/ServicesPage/ServicesPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6EAA6E;EAC7E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8EAA8E;EAC9E,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;;;AAIA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;AAEF","sourcesContent":["/* Services Page Styles */\n.services-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n}\n\n.services-main {\n  padding-top: 120px;\n  min-height: 100vh;\n}\n\n.services-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Header Section */\n.services-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.services-title-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.services-emoji {\n  font-size: 48px;\n  animation: bounce 2s infinite;\n}\n\n.services-title {\n  font-size: 48px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.services-subtitle {\n  font-size: 18px;\n  color: var(--text-secondary);\n  margin: 0;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Services Content */\n.services-content {\n  margin-bottom: 80px;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n  margin-bottom: 80px;\n}\n\n.service-card {\n  background: var(--accent-cream);\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  padding: 32px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 15px var(--shadow-color);\n}\n\n/* Dark theme card background */\n[data-theme=\"dark\"] .service-card {\n  background: rgba(44, 62, 80, 0.9);\n}\n\n.service-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--accent-coffee), var(--accent-beige));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px var(--shadow-color);\n  border-color: var(--accent-coffee);\n}\n\n.service-card:hover::before {\n  opacity: 1;\n}\n\n.service-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.service-icon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, var(--accent-coffee), var(--accent-beige));\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  flex-shrink: 0;\n}\n\n.service-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.service-description {\n  font-size: 16px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 24px;\n}\n\n.service-features {\n  margin-bottom: 24px;\n}\n\n.features-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n}\n\n.features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.feature-icon {\n  width: 20px;\n  height: 20px;\n  background: var(--accent-coffee);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: var(--accent-cream);\n  flex-shrink: 0;\n}\n\n\n\n/* Animations */\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .services-container {\n    padding: 0 16px;\n  }\n  \n  \n  .services-title {\n    font-size: 36px;\n  }\n  \n  .services-subtitle {\n    font-size: 16px;\n  }\n  \n  .services-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .service-card {\n    padding: 24px;\n  }\n  \n  .service-title {\n    font-size: 20px;\n  }\n  \n}\n\n@media (max-width: 480px) {\n  .services-title {\n    font-size: 28px;\n  }\n  \n  .service-card {\n    padding: 20px;\n  }\n  \n  .service-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n  \n  .service-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 24px;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
